"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var constants_1 = require("../../../constants");
var CalendarBar_1 = require("../../_shared/components/calendarBar/CalendarBar");
var layout_1 = require("../../_shared/components/layout");
var ReportDateRange = /** @class */ (function (_super) {
    __extends(ReportDateRange, _super);
    function ReportDateRange(props) {
        return _super.call(this, props) || this;
    }
    ReportDateRange.prototype.render = function () {
        return (React.createElement(layout_1.Wrapper, { className: "" },
            React.createElement(layout_1.Row, { justifyContent: "flex-start" },
                React.createElement("span", { className: "calender-bar-title" }, "Begindatum"),
                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.props.dateFrom, name: "dateFrom", max: moment(), onDateChange: this.props.onChangeDateFrom }),
                React.createElement(layout_1.Margin, { marginHorizontal: "20px" }),
                React.createElement("span", { className: "calender-bar-title" }, "Einddatum"),
                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.props.dateTo, name: "dateTo", max: moment(), onDateChange: this.props.onChangeDateTo }),
                React.createElement(layout_1.Margin, { marginHorizontal: "20px" }),
                React.createElement("button", { className: "button calender-bar-button", onClick: this.props.onGenerate }, "Rapport opstellen"))));
    };
    return ReportDateRange;
}(React.Component));
exports.default = ReportDateRange;
